<template>
  <div class="grid pointer" @click="clickGrid(item)">
    <img :src="imageUrl + item.studyCourse.logo" alt="">
    <p class="title e-2">{{item.studyCourse.name || ''}}</p>
  </div>
</template>

<script>
export default {
  props: {
    item: Object
  },
  name: "grid-box",
  data() {
    return {
      imageUrl: this.$API.BASE_URL
    }
  },
  methods: {
    clickGrid(item) {
      this.$emit('pages',item)
    }
  }
}
</script>

<style scoped lang="scss">
.grid {
  position: relative;
  margin-bottom: 20px;
  box-shadow: 0 4px 8px 0 rgb(95 101 105 / 5%);
  border-radius: 8px;
  background-color: #fff;
  transition: all .2s;

  &:hover {
    transform: scale(1.05);
  }

  img {
    border-radius: 8px 8px 0 0;
    width: 100%;
    height: 200px;
  }
  .title {
    color: #545c63;
    height: 40px;
    margin: 10px 0;
    padding: 0 8px;
  }
}
</style>
